/**
 * Parsing de search params que PRESERVA strings.
 *
 * O parser padrão do TanStack Router (`parseSearchWith(JSON.parse)`) tenta
 * converter cada valor com JSON.parse. Isso quebra os IDs do Zitadel, que são
 * snowflakes numéricos (ex.: "377838017118732293"): viram `number`, estouram
 * `Number.MAX_SAFE_INTEGER` e perdem precisão nos dígitos finais — e ainda fazem
 * o `typeof === 'string'` dos `validateSearch` falhar (resultando em `undefined`,
 * derrubando o callback do IdP com "Resposta do provedor inválida").
 *
 * Como TODOS os search params desta SPA são strings (`authRequestId`, `id`,
 * `token`), mantemos os valores crus, sem conversão. `URLSearchParams` cuida do
 * encode/decode percent.
 */
export function parseSearch(searchStr: string): Record<string, string> {
  const normalized = searchStr.startsWith('?') ? searchStr.slice(1) : searchStr;
  const params = new URLSearchParams(normalized);
  const result: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}

export function stringifySearch(search: Record<string, unknown>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  }
  const str = params.toString();
  return str ? `?${str}` : '';
}

/**
 * O id do pedido de autenticação do Zitadel, venha ele como `authRequestId` (o nome da
 * `ZITADEL_OIDC_DEFAULTLOGINURLV2` do compose) ou como `authRequest` (o nome que o Zitadel usa
 * quando a feature `login_v2` da instância tem `base_uri`, como numa instância recriada do zero:
 * aí ele monta `{base_uri}login?authRequest=` e ignora a URL do compose).
 */
export function authRequestIdDe(search: Record<string, unknown>): string | undefined {
  for (const chave of ['authRequestId', 'authRequest']) {
    const valor = search[chave];
    if (typeof valor === 'string' && valor !== '') return valor;
  }
  return undefined;
}
